module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll:[getElIdSelector()]",
      value: (_vm.onScroll),
      expression: "onScroll",
      arg: _vm.getElIdSelector()
    }, {
      name: "resize",
      rawName: "v-resize",
      value: (_vm.onResize),
      expression: "onResize"
    }],
    staticClass: "scroll-y",
    attrs: {
      "id": _vm.getElIdSelector().replace('#', ''),
      "height": _vm.internalHeight,
      "flat": _vm.flat
    }
  }, [(!_vm.md) ? _c('v-container', {
    ref: "slot",
    style: (_vm.style),
    attrs: {
      "px-2": "",
      "pt-2": "",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.md) ? _c('v-container', {
    ref: "slot",
    style: (_vm.style),
    attrs: {
      "px-1": "",
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_vm._t("default")], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76f96d79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CardScroll.vue
// module id = 800
// module chunks = 1